import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  MASTER_CONFIG_ITEM_LIST,
  MASTER_CONFIG_ITEM_CREATE,
  MASTER_CONFIG_ITEM_UPDATE,
} from "./actionType";

import {
  masterConfigItemListSuccess,
  masterConfigItemListFailure,
  masterConfigItemCreateSuccess,
  masterConfigItemCreateFailure,
  masterConfigItemUpdateSuccess,
  masterConfigItemUpdateFailure,
} from "./action";

import {
  getMasterConfigItemListAll,
  createMasterConfigItem,
  updateMasterConfigItem,
} from "../../helpers/fakebackend_helper";

// LIST
function* fetchMasterConfigItemList() {
  try {
    const response = yield call(getMasterConfigItemListAll);
    yield put(masterConfigItemListSuccess(response));
  } catch (error) {
    yield put(masterConfigItemListFailure(error));
  }
}
function* watchFetchMasterConfigItemList() {
  yield takeEvery(MASTER_CONFIG_ITEM_LIST, fetchMasterConfigItemList);
}

// CREATE
function* createMasterConfigItemSaga(action) {
  try {
    const response = yield call(createMasterConfigItem, action.payload);
    yield put(masterConfigItemCreateSuccess(response));
  } catch (error) {
    yield put(masterConfigItemCreateFailure(error));
  }
}
function* watchCreateMasterConfigItem() {
  yield takeEvery(MASTER_CONFIG_ITEM_CREATE, createMasterConfigItemSaga);
}

// UPDATE
function* updateMasterConfigItemSaga(action) {
  try {
    const response = yield call(updateMasterConfigItem, action.payload);
    yield put(masterConfigItemUpdateSuccess(response));
  } catch (error) {
    yield put(masterConfigItemUpdateFailure(error));
  }
}
function* watchUpdateMasterConfigItem() {
  yield takeEvery(MASTER_CONFIG_ITEM_UPDATE, updateMasterConfigItemSaga);
}

export default function* masterConfigItemSaga() {
  yield all([
    fork(watchFetchMasterConfigItemList),
    fork(watchCreateMasterConfigItem),
    fork(watchUpdateMasterConfigItem),
  ]);
}
